import React from 'react';
import Sticker from 'react-stickyfill';
import styled from 'styled-components';
import { media } from 'ui';
import PropTypes from 'prop-types';
import { useSpring, animated } from '@react-spring/web';
import { useSelector } from 'react-redux';
import { announcementBannerHeight } from 'utils/app-configs';

const StickyContainer = styled(animated.div)`
  position: -webkit-sticky;
  position: sticky;
  top: 161px;
  ${media.tablet`
    top: 55px;
    transform: unset !important;
  `};
  z-index: ${p => p.zIndex};
  ${p => p.extraStyles}
`;

/**
 * Component to make something sticky to top of page
 *
 * @param {boolean} menuVisible - comes out of the store
 * @param {string} translateYStart - translateY start in string format
 * @param {string} translateYEnd - translateY end in string format
 * @param {number} duration - duration of animation
 * @param {boolean} children - component that needs to be sticky
 */
const Sticky = ({
  menuVisible,
  translateYStart = '0px',
  translateYEnd = '-106px',
  duration = 400,
  children,
  extraStyles = '',
  zIndex = 110,
}) => {
  const { hasAnnouncementBanner } = useSelector(state => state.user);
  const translateYEndNum = Number(translateYEnd.replace('px', ''));
  const translateYEndUpdated = hasAnnouncementBanner ?
    `${translateYEndNum + announcementBannerHeight}px` :
    translateYEnd;

  const filterProps = useSpring({
    transform: menuVisible ?
      `translateY(${translateYStart})` :
      `translateY(${translateYEndUpdated})`,
    boxShadow: menuVisible ? '0px 0px 0px 0px gray' : '0px 7px 20px -7px gray',
    config: { duration },
  });

  return (
    <Sticker>
      <StickyContainer style={filterProps} extraStyles={extraStyles} zIndex={zIndex}>
        {children}
      </StickyContainer>
    </Sticker>
  );
};

Sticky.propTypes = {
  menuVisible: PropTypes.bool.isRequired,
  translateYStart: PropTypes.string,
  translateYEnd: PropTypes.string,
  duration: PropTypes.number,
  children: PropTypes.object,
  extraStyles: PropTypes.string,
  zIndex: PropTypes.number,
};

export default Sticky;
